export const enum UserPermissionState {
    Granted = 'granted',
    NotGranted = 'not_granted',
    Denied = 'denied',
}

export enum EPermissionState {
    GRANTED = 'granted',
    DENIED = 'denied',
    PROMPT = 'prompt',
}
